import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function BuyNow(props) {
  console.log(props);
  const prod = props.location.value;

  const [addQuantity, setaddQuantity] = useState(1);
  // const [disable, setDisable] = useState(false);

  const total = prod?.price * addQuantity;

  const disable = addQuantity === 1;

  function refreshPage() {
    window.location.reload();
  }

  return (
    <div className="buynow">
      <h2 className="text-center mb-4">
        <b>Buy Page</b>
      </h2>
      <div className="container text-center">
        <div className="row first">
          <div className="col-md-2">
            <img className="img-fluid" src={prod?.image} alt="" />
          </div>
          <div className="col-md-3 as">
            <h5>Product Name</h5>
            <h6>{prod?.name}</h6>
          </div>
          <div className="col-md-2 as">
            <h5>Product price</h5>
            <h6>₹{prod?.price}</h6>
          </div>
          <div className="col-md-2 as text-center">
            <h5>Product Quantity</h5>
            <div className="row ">
              <div className="as col-4">
                <button
                  className="form-control"
                  disabled={disable}
                  onClick={() => setaddQuantity(addQuantity - 1)}
                >
                  -
                </button>
              </div>
              <div className="as col-4">
                <h6> {addQuantity}</h6>
              </div>
              <div className="as col-4">
                <button
                  className="form-control"
                  onClick={() => setaddQuantity(addQuantity + 1)}
                >
                  +
                </button>
              </div>
            </div>
          </div>
          <div className="as col-md-3">
            <h5>Total Price</h5>
            <h6>₹{total}</h6>
          </div>
        </div>
        <div className="row">
          <div className="col-6"></div>
          <div className="col-6 ">
            <h3 className="paymod">Mode of Pay : Cash on delivery</h3>
            <h3 className="payorg">
              Original price : <b>₹{prod?.originalprice}</b>{" "}
            </h3>
            <h3>
              Total Amount : <b> ₹{total}</b>
            </h3>
          </div>
          <div className="row w-100 mt-4">
            <div className="col-12">
              <div className="text-right">
                <button
                  type="button"
                  className=" btn"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  Proceed to Pay
                </button>
              </div>
              <Link
                style={{
                  textDecoration: "none",
                  fontSize: "16px",
                }}
                className="btn "
                to="/Home"
              >
                Go To Homepage
              </Link>
              <div
                className="modal fade"
                id="exampleModal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-body">
                      <h3>Order Placed</h3>
                      <img
                        style={{ height: "200px", margin: "20px" }}
                        className="img-fluid"
                        src="https://www.flaticon.com/svg/vstatic/svg/3649/3649775.svg?token=exp=1615285815~hmac=a55d561563d21135d14d0e20f58f8bed"
                        alt=""
                      />
                      <p>Thanks for your order </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
